module.exports = __webpack_public_path__ + "static/media/code.55831e9d.jpg";